import { lazy, Suspense } from 'react';

/**
 * Lazy wrapper around STEP_ANIMATIONS from HowItWorksAnimations.
 *
 * The animation module pulls in framer-motion (~127 KB). Since the "How it
 * works" section sits below the fold on the ProductPage, we don't need it
 * for first paint / LCP. Loading it lazily keeps framer-motion out of the
 * critical bundle on every product page visit.
 */
const Step1 = lazy(() =>
  import('./HowItWorksAnimations').then((m) => ({ default: m.STEP_ANIMATIONS[1] })),
);
const Step2 = lazy(() =>
  import('./HowItWorksAnimations').then((m) => ({ default: m.STEP_ANIMATIONS[2] })),
);
const Step3 = lazy(() =>
  import('./HowItWorksAnimations').then((m) => ({ default: m.STEP_ANIMATIONS[3] })),
);

const STEPS: Record<number, React.LazyExoticComponent<React.ComponentType<{ metricLabel?: string }>>> = {
  1: Step1,
  2: Step2,
  3: Step3,
};

export default function HowItWorksStep({
  step,
  metricLabel,
}: {
  step: number;
  metricLabel?: string;
}) {
  const StepComp = STEPS[step];
  if (!StepComp) return null;
  return (
    <Suspense fallback={<div className="h-[120px]" aria-hidden />}>
      <StepComp metricLabel={metricLabel} />
    </Suspense>
  );
}